export default class SRCache{
	constructor(settings){
		this._ss = window.sessionStorage;

		settings = settings || {};

		this.sskey = settings.sskey || 'searchResultCache';

		if( !this._ss.getItem( this.sskey ) ) this._ss.setItem( this.sskey, '{}');
	}


	saveDataByState( state, saveData ){

		let itemKey = this.parseState( state );
		let data = this.getData();

		data[ itemKey ] = saveData;

		this._ss.setItem( this.sskey, JSON.stringify( data ) );

	}



	getDataByState( state ){

		let itemKey = this.parseState( state );
		let data = this.getData();

		for( let key in data ){

			if( itemKey === key ) return data[ key ];

		}

		return null;

	}



	getData(){

		return JSON.parse( this._ss.getItem( this.sskey ) );

	}



	/**
	 * Некрасиво, конечн, но ладно
	 * @param state
	 * @returns {string}
	 */
	parseState( state ){

		return 'Q:' + state.query.replace(/\s/gi, '_') + '-S:' + state.sort_by + '-P:' + state.page + '-' + state.limit;

	}
}



// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPageComponents/searchResultCache.js